import { createAction } from 'typesafe-actions';

import { EWorkplaceType } from 'shared/types/filters/wokplaceType';

export const changeWorkplaceTypeAction = createAction('filters/workplaceTypeChanged')<EWorkplaceType>();
